import { useRef, useState } from "react";
import { Autocomplete, Grid, TextField } from "../../../../components";
import { value } from "../../../../helpers";
import { NfEntradaService } from "../../../../services";
import { timeoutBuscaAutocomplete } from "../../../../utils";

const nfEntradaService = new NfEntradaService();

const FiltroImpressaoNfEntrada = ({
  nfEntrada, 
  setNfEntrada,
  listaOpcoesNfEntrada,
  setListaOpcoesNfEntrada,
  setFiltroImpressao,
  inputErros
}) => {

  const inputRef = useRef();
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);

  const buscaNfEntradas = (filtros) => {
    nfEntradaService.getAll(filtros).then((res) => {
      if (!res.isAxiosError) {
        setListaOpcoesNfEntrada(res.data.rows);
      } else {
        setListaOpcoesNfEntrada([]);
      }
    });
  }

  const onInputChange = (event) => {
    const eventValue = event.target?.value.includes(",")
      ? event.target?.value.split(",")[0]
      : event.target?.value;
    if (
      event.key === "Backspace" &&
      inputRef.current === document.activeElement &&
      eventValue === ""
    ) {
      setListaOpcoesNfEntrada([]);
    }
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      setLoadingAutoComplete(true);
      const filtros = {
        numeroNota: eventValue,
      };
      timeoutBuscaAutocomplete(buscaNfEntradas(filtros));
    }
  }

  const handleChangeAutocomplete = (event, value) => {
    setNfEntrada(value);
    setFiltroImpressao((prevState) => ({
      ...prevState,
      nfEntradaId: value?.id
    }));
  }

  return (
    <>
    <Grid item xs={6}>
      <Autocomplete
        required
        id="nfEntradaId"
        name="nfEntradaId"
        options={listaOpcoesNfEntrada}
        loading={loadingAutoComplete}
        noOptionsText="Sem opções"
        autoHighlight
        getOptionLabel={(option) =>
          option?.numeroNota && option?.serie
            ? `${option.numeroNota}/${option.serie}`
            : ""
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Pesquisar por Nº Nota"
            margin="normal"
            required
            onKeyDown={(e) => onInputChange(e)}
            inputRef={inputRef}
            InputProps={{
              ...params.InputProps,
            }}
            error={inputErros.get("nfEntradaId")}
          />
        )}
        onChange={handleChangeAutocomplete}
        value={value.autoComplete(listaOpcoesNfEntrada, nfEntrada?.id)}
      />
    </Grid>
    </>
  );
};

export default FiltroImpressaoNfEntrada;
